export enum SendByType {
    SMS = 1,
    WhatsApp = 2,
}